import React, { useEffect, useState } from 'react';
import Modal from './Modal';
import Button from './Button.js';
import BraRecommendationInitialContainer from '../../refresh/molecules/DressToolInitialPage';
import BraRecommendationFinalContainer from '../../refresh/molecules/DressToolFinalPage';

import BRTImageModule from '../../refresh/atoms/BraRecommendationToolImageGrid';
import classNames from 'classnames/bind';
import Slider from 'react-slick';
import { connect } from 'react-redux';
import { dressToolInitiateFinalFlag, dressToolInitiateInitialFlag, fetchDressToolApiData } from '../../actions/shared/braRecommendation';
import { getDressToolApiCall, getDressToolFlagData } from '../../refresh/selectors/braRecommedation';
import { fetchGetJSONReqOpts } from '../../modules/ajio-fetch/utils';
import fetcher from '../../modules/ajio-fetch';



const DressToolModal = ({ dressToolFlagReducer, initiateInitialFlag, initiateFinalFlag, showDressModal, fetchDressToolApiDataCall, getApiCallData }) => {
  const [selectedGrid, setSelectedGrid] = useState();
  const [skipFirstStepFlag, setSkipFirstStepFlag] = useState(false);

  function handleSelectionGrid(index) {
    setSelectedGrid(index);
  }

  const {initialStepsFlag,skipFirstStep,atcRecommendationStep} = dressToolFlagReducer;

  useEffect(() => {
    if (initialStepsFlag || skipFirstStep || atcRecommendationStep) {
      fetchDressToolApiDataCall();
    }
    if(skipFirstStep || atcRecommendationStep){                       //give final component logic that first step was there or not
      setSkipFirstStepFlag(true);
    }
    else if(initialStepsFlag){
      setSkipFirstStepFlag(false);
    }
  }, [initialStepsFlag, skipFirstStep, atcRecommendationStep]);
  return (<div>
    {getApiCallData?.questions && <div id="BraDressToolWrapper">
      <Modal show name="dress-tool-modal" className="dress-tool-modal-wrap">
        {(initialStepsFlag || skipFirstStep || atcRecommendationStep) && <BraRecommendationInitialContainer triggerFlag={initialStepsFlag || skipFirstStep || atcRecommendationStep} isDeskTop={true} />}
        {dressToolFlagReducer.finalStepFlag && <BraRecommendationFinalContainer data={dressToolFlagReducer?.dataForFinalStep[0]} triggerFlag={dressToolFlagReducer.finalStepFlag} isDeskTop={true} skipFirstStepFlag={skipFirstStepFlag} plpRedirectionUrl={getApiCallData?.plp_redirection_url}/>}

      </Modal>
    </div>}</div>
  );
};


const mapDispatchToProps = (dispatch) => {
  return {
    initiateFinalFlag: (finalPageData) => dispatch(dressToolInitiateFinalFlag(finalPageData)),
    initiateInitialFlag: () => dispatch(dressToolInitiateInitialFlag()),
    fetchDressToolApiDataCall: () => dispatch(fetchDressToolApiData()),
  };
};

const mapStateToProps = (state) => {
  return {
    dressToolFlagReducer: getDressToolFlagData(state),
    getApiCallData: getDressToolApiCall(state),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DressToolModal);



